import React from 'react';
import CountUp from 'react-countup';

const AnimatedCounter = ({ 
  end, 
  start = 0, 
  duration = 2000, 
  delay = 0, 
  suffix = '', 
  prefix = '',
  separator = ',',
  useEasing = true,
  preserveValue = true,
  ...props 
}) => {
  return (
    <CountUp
      start={start}
      end={end}
      duration={duration / 1000}
      delay={delay / 1000}
      separator={separator}
      prefix={prefix}
      suffix={suffix}
      useEasing={useEasing}
      preserveValue={preserveValue}
      {...props}
    />
  );
};

export default AnimatedCounter;